import { get, post } from '@/request/request'

export default {
  indexConfig() {
    return get('/admin/index')
  },
  dashboard() {
    return get('/admin/index/dashboard')
  },
  login(params) {
    return post('/admin/login', params)
  },
  logout() {
    return post('/admin/logout')
  },
  changePassword(params) {
    return post('/admin/change/password', params)
  }
}
